import {
  sendXhr
} from "../../../utils/send-xhr/send-xhr.js";

import {
  CONNECTOR_URL,
  RequestAction
} from "../const.js";

export default class PageViews {
  constructor() {
    this._resourceId = null;
  }

  init() {
    this._resourceId = document.body.dataset.resourceId;

    if (!this._resourceId) {
      return;
    }

    this._addView();
  }

  _addView() {
    const body = [
      `action=${RequestAction.ADD_VIEW}`,
      `resource_id=${this._resourceId}`
    ];

    const requestArgs = {
      body,
      connectorUrl: CONNECTOR_URL,
      loadCallback: (response) => {
        const data = JSON.parse(response);

        if (!data.success) {
          console.error(`There error during the resource page views incrementing has been occured!`);
        }
      }
    };
    sendXhr(requestArgs);
  }
}
